<template>
  <div class="container">
    <div class="selection" v-if="!(pagination.total === 0)">
      <h4 v-if="pagination.total !== 0">{{ $t('bannerManagement.listTitle') }}</h4>
      <a-button type="primary" @click="create" :disabled="data.length >= 6">{{ $t('bannerManagement.newBanner') }}</a-button>
    </div>
    <div v-if="pagination.total === 0" class="noData">
      <img src="@/assets/img/no_data_banner.png" alt="">
      <span>{{ $t('bannerManagement.noBanner') }}</span>
      <a-button type="primary" @click="create">{{ $t('bannerManagement.newBanner') }}</a-button>
    </div>
    <a-table
      v-else
      row-key="id"
      :columns="columns"
      :data-source="data">
      <template slot="bannerUrl" slot-scope="text">
        <div class="tableImg">
          <img class="ordinaryImg" :src="text" alt="">
          <img class="hoverImg" :src="text" alt="">
        </div>
      </template>
      <template slot="operate" slot-scope="text, record">
        <div class="operate">
          <span @click="edit(record)">{{ $t('bannerManagement.edit') }}</span>
          <span v-if="!record.isAdmin" @click="delModal(record.id)">{{ $t('bannerManagement.delete') }}</span>
        </div>
      </template>
    </a-table>
    <Pagination
      class="list-pagination"
      :pagination.sync="pagination"
      @handleTableChange="handleTableChange" />
    <TipModal
      @ok="del"
      :visible="delVisible"
      @cancel="delVisible = false"
      :desc="`
        <p>{{ $t('bannerManagement.deleteConfirmTitle') }}</p>
        <p class='placeholder'>{{ $t('bannerManagement.deleteConfirmContent') }}</p>`" />
  </div>
</template>

<script>
import { i18nRender } from '@/locales'
import {
  bannerDel,
  bannerList
} from '@/api/admin'
import { getListIndex } from '@/utils/other'
import TipModal from '@/components/tipModal/index.vue'
import { nameMap } from '@/utils/map'
import Pagination from '@/components/pagination/index.vue'

export default {
  components: {
    TipModal,
    Pagination
  },
  data() {
    return {
      delId: undefined,
      delVisible: false,
      columns: [
        {
          title: i18nRender('bannerManagement.id'),
          dataIndex: 'index',
          key: 'index'
        },
        {
          title: i18nRender('bannerManagement.image'),
          dataIndex: 'bannerUrl',
          scopedSlots: { customRender: 'bannerUrl' }
        },
        {
          title: i18nRender('bannerManagement.link'),
          dataIndex: 'targetUrl'
        },
        {
          title: i18nRender('bannerManagement.creationTime'),
          dataIndex: 'createdAt'
        },
        {
          title: i18nRender('bannerManagement.modificationTime'),
          dataIndex: 'updatedAt'
        },
        {
          title: i18nRender('bannerManagement.operation'),
          dataIndex: 'operate',
          scopedSlots: { customRender: 'operate' }
        }
      ],
      data: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    handleTableChange() {
      this.getBannerList()
    },
    create() {
      this.$router.push({
        name: 'bannerAdd'
      })
    },
    edit(record) {
      this.$router.push({
        name: 'bannerAdd',
        query: {
          id: record.id
        }
      })
    },
    delModal(id) {
      this.delVisible = true
      this.delId = id
    },
    del() {
      bannerDel({ id: this.delId }).then(res => {
        if (res.code == 200) {
          this.delVisible = false
          this.pagination.page = 1
          this.getBannerList()
          this.$message.success(i18nRender('bannerManagement.deleteSuccess'))
        }
      })
    },
    getBannerList() {
      const data = {
        page: this.pagination.page
      }
      bannerList(data).then(res => {
       if (res.code == 200) {
        this.data = getListIndex(res.data.list, this.pagination.page, this.pagination.pageSize)
        nameMap(this.data)
        this.pagination.total = res.data.total
        const permissionList = localStorage.permissionList
        this.noPermissionModal = !permissionList || !permissionList.includes('admin_banner')
       }
     })
    }
  },
  mounted() {
    this.getBannerList()
  }
}
</script>

<style lang="less" scoped>
.tableImg{
  position: relative;
  width: 69px;
  height: 39px;
  border-radius: 4px;
  .hoverImg{
    width: 0px;
    height: 142px;
    position: absolute;
    top: 0;
    left: 85px;
    z-index: 0;
    border: 2px solid #ffffff;
    transition: opacity 0.6s;
    opacity: 0;
  }
  &:hover{
    .ordinaryImg{
      border: 1px solid #ED9705;
    }
    .hoverImg{
      width: 252px;
      display: block;
      opacity: 1;
    }
  }

}
.container{
  /deep/ .ant-table {
    min-height: 583px;
  }
  position: relative;
  .list-pagination{
    position: absolute;
    // bottom: 50px;
    width: calc(100% - 44px);
  }
}
h4{
  font-size: 16px;
  font-weight: 800;
  color: #000000;
  line-height: 22px;
}
.admin{
  width: 100%;
  cursor: pointer;
  text-align: right;
  margin-bottom: 21px;
  .user-logo{
    width: 26px;
    height: 26px;
    border-radius: 100%;
    margin-right: 12px;
  }
  .down{
    width: 10px;
    margin-left: 5px;
  }
}
.selection{
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 22px;
  justify-content: space-between;
  align-items: center;
  /deep/.ant-input,
  /deep/.ant-input-affix-wrapper {
    width: 237px;
    height: 35px;
    color: #000;
    margin-right: 30px;
    border-radius: 20px;
    .ant-input-prefix,
    .ant-input-suffix{
      >img{
        width: 16px;
        cursor: pointer;
      }
    }
    .ant-input-suffix .clear{
      width: 14px;
      height: 14px;
    }
  }
}
.noData{
  display: flex;
  align-items: center;
  padding-bottom: 70px;
  flex-direction: column;
  justify-content: center;
  flex-direction: lab;
  height: calc(100% - 120px);
  img{
    width: 285px;
    margin-bottom: 12px;
  }
  > span{
    font-size: 14px;
    color: #0D2340;
    margin-top: -40px;
  }
  button{
    margin-top: 20px;
  }
}
/deep/.ant-input-suffix{
  right: 12px;
  img{
    width: 23px;
    cursor: pointer;
  }
}
/deep/.ant-form{
  .ant-form-item{
    margin-bottom: 22px;
    .ant-form-item-label{
      margin-bottom: 6px;
      line-height: normal !important;
    }
    &:last-child{
      margin-bottom: 0;
    }
  }
}
/deep/ .ant-btn.ant-btn-primary{
  width: auto;
}
</style>
